import 'react-notifications/lib/notifications.css';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Typography, Paper } from '@material-ui/core';
import SelectLocationsTable from '../add_accounts/SelectLocationsTable';
import ConnectGoogleAccount from '../add_accounts/ConnectGoogleAccount';

const pageWrapStyle = {
	padding: '0 16px',
	background: 'transparent',
};

const cardStyle = {
	width: '100%',
	margin: '0 auto',
	marginTop: 24,
	marginBottom: 24,
	borderRadius: 14,
	overflow: 'hidden',
	backgroundColor: '#fff',
	boxShadow: '0 10px 30px rgba(15, 23, 42, 0.08)',
	border: '1px solid #eef2f7',
};

const cardTopAccentStyle = {
	height: 8,
	background:
		'linear-gradient(90deg, rgba(198,85,214,1) 0%, rgba(198,85,214,0.45) 45%, rgba(15,23,42,0.65) 100%)',
};

const cardContentStyle = {
	padding: '28px 28px 26px',
	textAlign: 'center',
};

const titleStyle = {
	color: '#0f172a',
	fontWeight: 700,
	letterSpacing: '-0.4px',
	marginBottom: 10,
};

const subtitleStyle = {
	color: '#475569',
	fontSize: '1rem',
	lineHeight: 1.6,
	maxWidth: 640,
	margin: '0 auto 18px',
};

class AddAccountsDashboard extends Component {
	async componentDidMount() {
		document.title = 'Add Locations | Chekkit Enterprise';
	}

	renderGoogleAccount = () => (
		<div style={pageWrapStyle}>
			<Paper elevation={0} style={cardStyle}>
				<div style={cardTopAccentStyle} />
				<div style={cardContentStyle}>
					<Typography variant="h5" style={titleStyle}>
						Add your business locations
					</Typography>
					<Typography style={subtitleStyle}>
						Connect Google to import your locations into Chekkit, then
						select which ones you want to manage.
					</Typography>
					<ConnectGoogleAccount />
				</div>
			</Paper>
		</div>
	);

	renderFacebookAccount = () => null;

	renderSelectLocationsTable = () => <SelectLocationsTable />;

	render() {
		if (this.props.auth) {
			if (!this.props.auth.googleRefresh) {
				return this.renderGoogleAccount();
			}

			if (
				this.props.auth.googleRefresh &&
				!this.props.auth.facebookPageAccessToken
			) {
				return (
					<div>
						{this.renderSelectLocationsTable()}{' '}
						{this.renderFacebookAccount()}
					</div>
				);
			}

			return this.renderSelectLocationsTable();
		}

		return (
			<div style={pageWrapStyle}>
				<Paper elevation={0} style={cardStyle}>
					<div style={cardTopAccentStyle} />
					<div style={cardContentStyle}>
						<Typography variant="h5" style={titleStyle}>
							Sign in to Chekkit
						</Typography>
						<Typography style={subtitleStyle}>
							Please sign in to access your locations and manage your
							accounts.
						</Typography>
						<Button
							variant="contained"
							disableElevation
							href="/api/logout"
							style={{
								backgroundColor: '#c655d6',
								color: '#fff',
								textTransform: 'none',
								padding: '10px 18px',
								borderRadius: 10,
								fontWeight: 700,
							}}
						>
							Sign in
						</Button>
					</div>
				</Paper>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return { error: state.error, auth: state.auth };
}

export default connect(mapStateToProps)(AddAccountsDashboard);



// WEBPACK FOOTER //
// ./src/components/dashboards/AddAccountsDashboard.js